module.exports = __webpack_public_path__ + "static/media/logo-polar-night-3.15f1c74d.png";